import { Arbor } from "@/pages/catalogs/models/Arbor";
import { ErrorModal } from "@dexteel/mesf-core";
import { Grid2, TextField } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { Part } from "../../models/Part";
import { getArbors } from "../../repositories/parts/ArborRepository";

type useArborsProps = {
	partId: number;
	onError: (error: Error) => void;
	onSuccess?: (data: Arbor[]) => void;
};

export const useArbors = ({ partId, onError, onSuccess }: useArborsProps) => {
	return useQuery<Arbor[], Error>({
		queryKey: ["arbors", partId],
		queryFn: ({ signal }) => getArbors({ partId }, signal),
		onError: onError,
		onSuccess: onSuccess,
	});
};

type Props = {
	part: Part | null;
};

export const SpecificArborData = ({ part }: Props) => {
	const [error, setError] = useState("");
	const [arbor, setArbor] = useState<Arbor>();

	const { data: arbors } = useArbors({
		partId: part?.PartId!,
		onError: (error) => setError(error.message),
		onSuccess: (data: Arbor[]) => {
			setArbor(data[0]);
		},
	});

	return (
		<>
			<Grid2 container spacing={1}>
				<Grid2 size={{ xs: 12, sm: 12, md: 12 }}>
					<TextField value={arbor?.Stands || ""} label="Stands" disabled />
				</Grid2>
			</Grid2>
			<ErrorModal error={error} onHide={() => setError("")} />
		</>
	);
};
